<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="500px"
    scrollable
    @keydown.esc="dialog = false"
  >
    <card>
      <card-title>Изменение поля «{{ fieldTitle }}»</card-title>
      <card-content class="pt-6">
        <v-row dense>
          <v-col cols="12">
            <tags-editor
              id="form-autocomplete-mass-tags-add"
              v-model="tagsAdd"
              :tag="{
                name: 'tags-add',
                description: `Добавить ${fieldTitle}`,
                custom_settings: {}
              }"
              :dic="dicTags"
              attach-fixed
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <tags-editor
              id="form-autocomplete-mass-tags-remove"
              v-model="tagsRemove"
              :disabled="tagsRemoveAll"
              :tag="{
                name: 'tags-remove',
                description: `Удалить ${fieldTitle}`,
                custom_settings: {}
              }"
              :dic="dicTags"
              attach-fixed
            />
            <v-checkbox
              v-model="tagsRemoveAll"
              label="Удалить все тэги"
              class="mt-0 pt-0"
              hide-details
            />
          </v-col>
        </v-row>
      </card-content>
      <card-actions>
        <v-btn
          id="add-product-btn-execute"
          color="primary"
          depressed
          @click="onExecute"
        >
          Выполнить
        </v-btn>
        <v-btn
          id="add-product-btn-cancel"
          color="primary"
          depressed
          outlined
          @click="dialog = false"
        >
          Отменить
        </v-btn>
      </card-actions>
    </card>
  </v-dialog>
</template>
<script>
import TagsEditor from "../../Node/Editors/TagsEditor.vue";
export default {
  name: "MassAssignmentTags",
  components: {
    TagsEditor
  },
  model: {
    prop: "open",
    event: "change"
  },
  props: {
    open: Boolean,
    fieldName: {
      type: String,
      required: true
    },
    fieldTitle: {
      type: String,
      required: true
    },
    dicName: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      tagsAdd: [],
      tagsRemove: [],
      tagsRemoveAll: false
    };
  },

  computed: {
    dialog: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("change", value);
      }
    },
    dicTags() {
      const dic = this.$store.getters.getDicNames.find(
        dic => dic.name == this.dicName
      );
      return this.$store.getters.getDic(dic.id, "en");
    }
  },

  watch: {
    open(newVal) {
      if (newVal) {
        this.resetForm();
      } else if (!newVal) {
        this.$emit("close");
      }
    },
    tagsRemoveAll(newVal) {
      if (newVal === true) {
        this.tagsRemove = [];
      }
    }
  },

  methods: {
    async onExecute() {
      const { tagsAdd, tagsRemove, tagsRemoveAll, fieldName } = this;
      this.$emit("apply", {
        data: { tagsAdd, tagsRemove, tagsRemoveAll },
        fieldName
      });
      this.dialog = false;
    },
    resetForm() {
      this.tagsAdd = [];
      this.tagsRemove = [];
      this.tagsRemoveAll = false;
    }
  }
};
</script>
